<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <v-row class="mt-10">
    <v-col cols="12" md="12">
      <v-row
        :class="$style.hrQuestion"
        class="my-auto offblack--text"
        justify="center"
        align="center"
        no-gutters
      >
        For my eyes only?
      </v-row>
    </v-col>
    <v-row>
      <v-row align="center" justify="center" no-gutters>
        <v-radio-group
          :key="'radio-2'"
          :value="value"
          row
          :class="$style.hrRadio"
          :disabled="disabled"
        >
          <v-radio
            label="No"
            :value="false"
            @change="$emit('update:value', false)"
          ></v-radio>
          <v-radio
            label="Yes"
            :value="true"
            @change="$emit('update:value', true)"
          ></v-radio>
        </v-radio-group>
      </v-row>
    </v-row>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.hrQuestion {
  // styleName: Desktop/Display X-Small;
  font-family: $system-default-font-family;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
}
.hrRadio {
  // styleName: Mobile / Display Small;
  font-family: $system-default-font-family;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}
</style>
